import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DataAccessFairsService } from '../services/fairs/data-access-fairs.service';
import { DataAccessFairsEffects } from '../states/fairs/entity/data-access-fairs.effects';
import { DataAccessFairsFacade } from '../states/fairs/entity/data-access-fairs.facade';
import * as fromFairDataFairs from '../states/fairs/entity/data-access-fairs.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromFairDataFairs.DATA_ACCESS_FAIRS_FEATURE_KEY, fromFairDataFairs.fairsReducer),
    EffectsModule.forFeature([DataAccessFairsEffects]),
  ],
  providers: [DataAccessFairsService, DataAccessFairsFacade],
})
export class Bau365DataAccessFairConfigModule {}
